import axiosInstance from '../../../core/api/axios';
import { ILesson, IModules, IPodcasts } from '../../../core/models/disciplines';
import { ISubject } from '../../../core/models/subject';

import {
  IDislike,
  IFavoriteMaterial,
  IGetReview,
  ILike,
} from '../models/modules';
import { useDisciplineStore } from '../stores/disciplineStore';
import { useModuleStore } from '../stores/moduleStore';
import { useSubjectStore } from '../stores/subjectStore';
import { getActiveItem } from '../utils/disciplineHelper';

export interface options {
  page: number;
  difficulty: string;
  questionOptions: string;
  trialOptions: string;
}

export async function getModules(discipline: string): Promise<IModules[]> {
  try {
    const { data } = await axiosInstance.get(`/areas/${discipline}/subareas`);

    return data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getSubjects(module: string): Promise<ISubject[]> {
  try {
    const modules = useModuleStore.getState().modules;
    const subjects = useSubjectStore.getState().subjects;
    const active = useSubjectStore.getState().active;
    const setActive = useSubjectStore.getState().setActive;
    const setSubjects = useSubjectStore.getState().setSubjects;
    const setActiveModule = useDisciplineStore.getState().setActiveModule;
    const setIsLoading = useSubjectStore.getState().setIsLoading;
  
    setIsLoading(true);
    let data: ISubject[] = [];

    if (active?.slug !== module || !active) {
      const response = await axiosInstance.get(
        `/subjects/${module}/getsubjects`
      );
      const activeItem = getActiveItem(modules, module, 'normal');

      data = response.data;
      setSubjects(data);
      setActive(activeItem);
      setActiveModule(activeItem);
    } else {
      data = subjects || [];
    }

    setIsLoading(false);
    return data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getLesson(module: string): Promise<ILesson[]> {
  try {
    const { data: { lessons } } = await axiosInstance.get(`/subareas/${module}/lessons?`);

    return lessons;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getMaterials(module: string) {
  try {
    const { data } = await axiosInstance.get(`/subareas/${module}/workbooks`); 

    return data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getPodcasts(module: string): Promise<IPodcasts[]> {
  try {
    const { data: { podcasts } } = await axiosInstance.get(`/subareas/${module}/podcasts`);

    return podcasts;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function likeMaterial(id: string): Promise<ILike[]> {
  try {
    const response = await axiosInstance.post(`/reviewmaterial/${id}/like`);
    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function dislikeMaterial(id: string): Promise<IDislike[]> {
  try {
    const response = await axiosInstance.post(`/reviewmaterial/${id}/dislike`);
    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function favoriteMaterial(
  targetId: string,
  targetType: string,
  category: string
): Promise<IFavoriteMaterial> {
  try {
    const body = {
      targetId,
      targetType,
      category,
    };
    const response = await axiosInstance.post(`/favorites`, body);
    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getReview(slug: string): Promise<IGetReview> {
  try {
    const response = await axiosInstance.get(`/workbooks/${slug}`);
    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getExerciseResolution(slug: string): Promise<any> {
  try {
    const { data } = await axiosInstance.get(`/exercises/resolution/${slug}`);

    return data;
  } catch (e: any) {
    throw new Error(e);
  }
}
